import { useCdpContext } from 'state/cdp';
import { ClickEventComponentNames, CustomEventNames, EventTypes } from 'state/cdp/constants';

export const useTabbedHeaderAnalytics = () => {
  const cdp = useCdpContext();

  const logTabSelected = (entry: string, tabId: string): void => {
    cdp.trackEvent({
      name: CustomEventNames.TABBED_HEADER,
      type: EventTypes.Navigation,
    });
    cdp.trackEvent({
      name: CustomEventNames.CLICK_EVENT,
      type: EventTypes.Navigation,
      attributes: {
        component: ClickEventComponentNames.PRODUCT_SECTION_TABS,
        text: entry,
        componentId: tabId,
      },
    });
  };

  return logTabSelected;
};
